import { Link, useLocation } from '@/lib/router-compat';
import { ChevronRight, Home } from 'lucide-react';
import { breadcrumbsFor } from '@/lib/navigation';

/** Shows where you are and gives a one-click way back up. */
export function AppBreadcrumbs() {
  const { pathname } = useLocation();
  const crumbs = breadcrumbsFor(pathname);

  if (crumbs.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="px-4 md:px-6 py-2">
      <ol className="flex flex-wrap items-center gap-1 text-xs text-primary-foreground/70">
        <li className="flex items-center gap-1">
          <Link
            to="/dashboard"
            className="flex items-center gap-1 rounded px-1.5 py-0.5 hover:bg-primary-foreground/10 hover:text-primary-foreground transition-colors"
          >
            <Home className="h-3 w-3" aria-hidden="true" />
            <span>Home</span>
          </Link>
        </li>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <li key={crumb.to} className="flex items-center gap-1">
              <ChevronRight className="h-3 w-3 opacity-50" aria-hidden="true" />
              {isLast ? (
                <span aria-current="page" className="px-1.5 py-0.5 font-medium text-primary-foreground">
                  {crumb.label}
                </span>
              ) : (
                <Link
                  to={crumb.to}
                  className="rounded px-1.5 py-0.5 hover:bg-primary-foreground/10 hover:text-primary-foreground transition-colors"
                >
                  {crumb.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
